var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3105 17.5254C11.9414 17.5254 13.4453 16.998 14.6758 16.1191L19.3047 20.748C19.5195 20.9629 19.8027 21.0703 20.1055 21.0703C20.7402 21.0703 21.1895 20.582 21.1895 19.957C21.1895 19.6641 21.0918 19.3906 20.877 19.1758L16.2773 14.5664C17.2441 13.2969 17.8203 11.7246 17.8203 10.0156C17.8203 5.88477 14.4414 2.50586 10.3105 2.50586C6.17969 2.50586 2.80078 5.88477 2.80078 10.0156C2.80078 14.1465 6.17969 17.5254 10.3105 17.5254ZM10.3105 15.9043C7.08789 15.9043 4.42188 13.2383 4.42188 10.0156C4.42188 6.79297 7.08789 4.12695 10.3105 4.12695C13.5332 4.12695 16.1992 6.79297 16.1992 10.0156C16.1992 13.2383 13.5332 15.9043 10.3105 15.9043Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.b70ced23cc7a009a902eecf760a11b8e.svg";
export { ForwardRef as ReactComponent };